import authHeaders from 'helpers/auth-header';
import request from './api';

function getAnnouncements() {
  return request({
    url: `/announcement/getAll`,
    method: 'GET',
    headers: authHeaders(),
  });
}
function addAnnouncement(body) {
  return request({
    url: `/announcement`,
    method: 'POST',
    headers: authHeaders(),
    data: { ...body },
  });
}
function updateAnnouncement(body) {
  return request({
    url: `/announcement`,
    method: 'PUT',
    headers: authHeaders(),
    data: { ...body },
  });
}

function deleteAnnouncement(id) {
  return request({
    url: `/announcement/delete-announcement/id/${id}`,
    method: 'POST',
    headers: authHeaders(),
  });
}
function notificationAnnouncement() {
  return request({
    url: `/announcement/notifications`,
    method: 'GET',
    headers: authHeaders(),
  });
}

const announcement = {
  getAnnouncements,
  addAnnouncement,
  updateAnnouncement,
  deleteAnnouncement,
  notificationAnnouncement,
};

export default announcement;
